import {
  IndexOutOfBoundsException_init_$Create$jb51qtvf74or as IndexOutOfBoundsException_init_$Create$,
  Long2qws0ah9gnpki as Long,
  IllegalArgumentException_init_$Create$310sysrobvll9 as IllegalArgumentException_init_$Create$,
  _Char___init__impl__6a9atx281r2pd9o601g as _Char___init__impl__6a9atx,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  Unit_instance104q5opgivhr8 as Unit_instance,
  toShort36kaw0zjdq3ex as toShort,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  toLongw1zpgk99d84b as toLong,
  StringBuilder_init_$Create$23o1ixl6cos5l as StringBuilder_init_$Create$,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  IllegalStateException_init_$Create$3ib9qa3pip8n4 as IllegalStateException_init_$Create$,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  arrayCopytctsywo3h7gj as arrayCopy,
  toByte4i43936u611k as toByte,
  IllegalArgumentException_init_$Create$2lx7x8ynu2218 as IllegalArgumentException_init_$Create$_0,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd2xlaiz5u3itpv as Char__toInt_impl_vasixd,
  charArray2ujmm1qusno00 as charArray,
  numberToChar93r9buh19yek as numberToChar,
  concatToString3cxf0c1gqonpo as concatToString,
  Exception_init_$Init$1f5sozasf31ba as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  Exception_init_$Init$32vb8wlewqrmh as Exception_init_$Init$_0,
  Exception_init_$Init$2fx1sms2m4tu1 as Exception_init_$Init$_1,
  Exceptiondt2hlxn7j7vw as Exception,
} from './kotlin-kotlin-stdlib.mjs';
import { UnsafeByteStringOperations_instance39s7tll95rf4n as UnsafeByteStringOperations_instance } from './kotlinx-io-kotlinx-io-bytestring.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(Source, 'Source', VOID, VOID, [AutoCloseable]);
function write$default(source, startIndex, endIndex, $super) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? source.length : endIndex;
  var tmp;
  if ($super === VOID) {
    this.t39(source, startIndex, endIndex);
    tmp = Unit_instance;
  } else {
    tmp = $super.t39.call(this, source, startIndex, endIndex);
  }
  return tmp;
}
initMetadataForInterface(Sink, 'Sink', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Buffer, 'Buffer', Buffer, VOID, [Source, Sink]);
initMetadataForClass(PeekSource, 'PeekSource', VOID, VOID, [AutoCloseable]);
initMetadataForClass(RealSource, 'RealSource', VOID, VOID, [Source]);
initMetadataForCompanion(Companion);
initMetadataForClass(Segment, 'Segment');
initMetadataForClass(SegmentCopyTracker, 'SegmentCopyTracker');
initMetadataForObject(AlwaysSharedCopyTracker, 'AlwaysSharedCopyTracker', VOID, SegmentCopyTracker);
initMetadataForObject(UnsafeBufferOperations, 'UnsafeBufferOperations');
initMetadataForClass(SegmentReadContextImpl$1);
initMetadataForClass(SegmentWriteContextImpl$1);
initMetadataForClass(BufferIterationContextImpl$1);
initMetadataForClass(IOException, 'IOException', IOException_init_$Create$, Exception);
initMetadataForClass(EOFException, 'EOFException', EOFException_init_$Create$, IOException);
initMetadataForObject(SegmentPool, 'SegmentPool');
//endregion
function get_HEX_DIGIT_CHARS() {
  _init_properties__Util_kt__g8tcl9();
  return HEX_DIGIT_CHARS;
}
var HEX_DIGIT_CHARS;
function checkBounds(size, startIndex, endIndex) {
  _init_properties__Util_kt__g8tcl9();
  if (startIndex.b1(new Long(0, 0)) < 0 || endIndex.b1(size) > 0) {
    throw IndexOutOfBoundsException_init_$Create$('startIndex (' + startIndex.toString() + ') and endIndex (' + endIndex.toString() + ') are not within the range [0..size(' + size.toString() + '))');
  }
  if (startIndex.b1(endIndex) > 0) {
    throw IllegalArgumentException_init_$Create$('startIndex (' + startIndex.toString() + ') > endIndex (' + endIndex.toString() + ')');
  }
}
function checkOffsetAndCount(size, offset, byteCount) {
  _init_properties__Util_kt__g8tcl9();
  if (offset.b1(new Long(0, 0)) < 0 || offset.b1(size) > 0 || size.s2(offset).b1(byteCount) < 0 || byteCount.b1(new Long(0, 0)) < 0) {
    throw IllegalArgumentException_init_$Create$('offset (' + offset.toString() + ') and byteCount (' + byteCount.toString() + ') are not within the range [0..size(' + size.toString() + '))');
  }
}
var properties_initialized__Util_kt_67kc5b;
function _init_properties__Util_kt__g8tcl9() {
  if (!properties_initialized__Util_kt_67kc5b) {
    properties_initialized__Util_kt_67kc5b = true;
    // Inline function 'kotlin.charArrayOf' call
    HEX_DIGIT_CHARS = charArrayOf([_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(49), _Char___init__impl__6a9atx(50), _Char___init__impl__6a9atx(51), _Char___init__impl__6a9atx(52), _Char___init__impl__6a9atx(53), _Char___init__impl__6a9atx(54), _Char___init__impl__6a9atx(55), _Char___init__impl__6a9atx(56), _Char___init__impl__6a9atx(57), _Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(98), _Char___init__impl__6a9atx(99), _Char___init__impl__6a9atx(100), _Char___init__impl__6a9atx(101), _Char___init__impl__6a9atx(102)]);
  }
}
function throwEof($this, byteCount) {
  throw EOFException_init_$Create$_0("Buffer doesn't contain required number of bytes (size: " + $this.m().toString() + ', required: ' + byteCount.toString() + ')');
}
function Buffer() {
  this.g38_1 = null;
  this.h38_1 = null;
  this.i38_1 = new Long(0, 0);
}
protoOf(Buffer).m = function () {
  return this.i38_1;
};
protoOf(Buffer).j38 = function () {
  return this;
};
protoOf(Buffer).k38 = function () {
  return this.m().equals(new Long(0, 0));
};
protoOf(Buffer).l38 = function (byteCount) {
  // Inline function 'kotlin.require' call
  if (!(byteCount.b1(new Long(0, 0)) >= 0)) {
    var message = 'byteCount: ' + byteCount.toString();
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (this.m().b1(byteCount) < 0) {
    throw EOFException_init_$Create$_0("Buffer doesn't contain required number of bytes (size: " + this.m().toString() + ', required: ' + byteCount.toString() + ')');
  }
};
protoOf(Buffer).m38 = function (byteCount) {
  // Inline function 'kotlin.require' call
  if (!(byteCount.b1(new Long(0, 0)) >= 0)) {
    var message = 'byteCount: ' + byteCount.toString() + ' < 0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return this.m().b1(byteCount) >= 0;
};
protoOf(Buffer).n38 = function () {
  var tmp0_elvis_lhs = this.g38_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwEof(this, new Long(1, 0));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var segment = tmp;
  var segmentSize = segment.m();
  if (segmentSize === 0) {
    this.v38();
    return this.n38();
  }
  var v = segment.w38();
  this.i38_1 = this.i38_1.s2(new Long(1, 0));
  if (segmentSize === 1) {
    this.v38();
  }
  return v;
};
protoOf(Buffer).x38 = function () {
  var tmp0_elvis_lhs = this.g38_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwEof(this, new Long(2, 0));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var segment = tmp;
  var segmentSize = segment.m();
  if (segmentSize < 2) {
    this.l38(new Long(2, 0));
    if (segmentSize === 0) {
      this.v38();
      return this.x38();
    }
    // Inline function 'kotlinx.io.and' call
    var tmp_0 = (this.n38() & 255) << 8;
    // Inline function 'kotlinx.io.and' call
    var tmp$ret$1 = this.n38() & 255;
    return toShort(tmp_0 | tmp$ret$1);
  }
  var v = segment.y38();
  this.i38_1 = this.i38_1.s2(new Long(2, 0));
  if (segmentSize === 2) {
    this.v38();
  }
  return v;
};
protoOf(Buffer).z38 = function () {
  return Unit_instance;
};
protoOf(Buffer).a39 = function (out, startIndex, endIndex) {
  checkBounds(this.m(), startIndex, endIndex);
  if (startIndex.equals(endIndex))
    return Unit_instance;
  var currentOffset = startIndex;
  var remainingByteCount = endIndex.s2(startIndex);
  out.i38_1 = out.i38_1.r2(remainingByteCount);
  var s = this.g38_1;
  while (currentOffset.b1(toLong(ensureNotNull(s).q38_1 - s.p38_1 | 0)) >= 0) {
    currentOffset = currentOffset.s2(toLong(s.q38_1 - s.p38_1 | 0));
    s = s.t38_1;
  }
  while (remainingByteCount.b1(new Long(0, 0)) > 0) {
    var copy = ensureNotNull(s).b39();
    copy.p38_1 = copy.p38_1 + currentOffset.d1() | 0;
    var tmp = copy;
    var tmp0 = copy.p38_1 + remainingByteCount.d1() | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = copy.q38_1;
    tmp.q38_1 = Math.min(tmp0, b);
    // Inline function 'kotlinx.io.Buffer.pushSegment' call
    if (out.g38_1 == null) {
      out.g38_1 = copy;
      out.h38_1 = copy;
    } else if (false) {
      out.h38_1 = ensureNotNull(out.h38_1).c39(copy).d39();
      if (ensureNotNull(out.h38_1).u38_1 == null) {
        out.g38_1 = out.h38_1;
      }
    } else {
      out.h38_1 = ensureNotNull(out.h38_1).c39(copy);
    }
    remainingByteCount = remainingByteCount.s2(toLong(copy.q38_1 - copy.p38_1 | 0));
    currentOffset = new Long(0, 0);
    s = s.t38_1;
  }
};
protoOf(Buffer).e39 = function () {
  var result = this.m();
  if (result.equals(new Long(0, 0)))
    return new Long(0, 0);
  var tail = ensureNotNull(this.h38_1);
  if (tail.q38_1 < 8192 && tail.s38_1) {
    result = result.s2(toLong(tail.q38_1 - tail.p38_1 | 0));
  }
  return result;
};
protoOf(Buffer).f39 = function (position) {
  if (position.b1(new Long(0, 0)) < 0 || position.b1(this.m()) >= 0) {
    throw IndexOutOfBoundsException_init_$Create$('position (' + position.toString() + ') is not within the range [0..size(' + this.m().toString() + '))');
  }
  if (position.equals(new Long(0, 0))) {
    return ensureNotNull(this.g38_1).g39(0);
  }
  // Inline function 'kotlinx.io.seek' call
  if (this.g38_1 == null) {
    var offset = new Long(-1, -1);
    return ensureNotNull(null).g39(position.s2(offset).d1());
  }
  if (this.m().s2(position).b1(position) < 0) {
    var s = this.h38_1;
    var offset_0 = this.m();
    $l$loop: while (!(s == null) && offset_0.b1(position) > 0) {
      offset_0 = offset_0.s2(toLong(s.q38_1 - s.p38_1 | 0));
      if (offset_0.b1(position) <= 0)
        break $l$loop;
      s = s.u38_1;
    }
    var tmp4 = s;
    var offset_1 = offset_0;
    return ensureNotNull(tmp4).g39(position.s2(offset_1).d1());
  } else {
    var s_0 = this.g38_1;
    var offset_2 = new Long(0, 0);
    $l$loop_0: while (!(s_0 == null)) {
      var tmp0 = offset_2;
      // Inline function 'kotlin.Long.plus' call
      var other = s_0.q38_1 - s_0.p38_1 | 0;
      var nextOffset = tmp0.r2(toLong(other));
      if (nextOffset.b1(position) > 0)
        break $l$loop_0;
      s_0 = s_0.t38_1;
      offset_2 = nextOffset;
    }
    var tmp6 = s_0;
    var offset_3 = offset_2;
    return ensureNotNull(tmp6).g39(position.s2(offset_3).d1());
  }
};
protoOf(Buffer).d2 = function () {
  return this.h39(this.m());
};
protoOf(Buffer).h39 = function (byteCount) {
  // Inline function 'kotlinx.io.checkByteCount' call
  // Inline function 'kotlin.require' call
  if (!(byteCount.b1(new Long(0, 0)) >= 0)) {
    var message = 'byteCount (' + byteCount.toString() + ') < 0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var remainingByteCount = byteCount;
  while (remainingByteCount.b1(new Long(0, 0)) > 0) {
    var tmp0_elvis_lhs = this.g38_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw EOFException_init_$Create$_0('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var head = tmp;
    var tmp1 = remainingByteCount;
    // Inline function 'kotlinx.io.minOf' call
    var b = head.q38_1 - head.p38_1 | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b_0 = toLong(b);
    var toSkip = (tmp1.b1(b_0) <= 0 ? tmp1 : b_0).d1();
    this.i38_1 = this.i38_1.s2(toLong(toSkip));
    remainingByteCount = remainingByteCount.s2(toLong(toSkip));
    head.p38_1 = head.p38_1 + toSkip | 0;
    if (head.p38_1 === head.q38_1) {
      this.v38();
    }
  }
};
protoOf(Buffer).i39 = function (sink, startIndex, endIndex) {
  // Inline function 'kotlinx.io.checkBounds' call
  var size = sink.length;
  checkBounds(toLong(size), toLong(startIndex), toLong(endIndex));
  var tmp0_elvis_lhs = this.g38_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return -1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var s = tmp;
  var tmp3 = endIndex - startIndex | 0;
  // Inline function 'kotlin.comparisons.minOf' call
  var b = s.m();
  var toCopy = Math.min(tmp3, b);
  s.j39(sink, startIndex, startIndex + toCopy | 0);
  this.i38_1 = this.i38_1.s2(toLong(toCopy));
  if (isEmpty(s)) {
    this.v38();
  }
  return toCopy;
};
protoOf(Buffer).k39 = function (sink, byteCount) {
  // Inline function 'kotlinx.io.checkByteCount' call
  // Inline function 'kotlin.require' call
  if (!(byteCount.b1(new Long(0, 0)) >= 0)) {
    var message = 'byteCount (' + byteCount.toString() + ') < 0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (this.m().equals(new Long(0, 0)))
    return new Long(-1, -1);
  var bytesWritten = byteCount.b1(this.m()) > 0 ? this.m() : byteCount;
  sink.l39(this, bytesWritten);
  return bytesWritten;
};
protoOf(Buffer).m39 = function (sink, byteCount) {
  // Inline function 'kotlinx.io.checkByteCount' call
  // Inline function 'kotlin.require' call
  if (!(byteCount.b1(new Long(0, 0)) >= 0)) {
    var message = 'byteCount (' + byteCount.toString() + ') < 0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (this.m().b1(byteCount) < 0) {
    sink.l39(this, this.m());
    throw EOFException_init_$Create$_0('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.m().toString() + ' bytes were written.');
  }
  sink.l39(this, byteCount);
};
protoOf(Buffer).n39 = function (sink) {
  var byteCount = this.m();
  if (byteCount.b1(new Long(0, 0)) > 0) {
    sink.l39(this, byteCount);
  }
  return byteCount;
};
protoOf(Buffer).o39 = function () {
  return buffered(new PeekSource(this));
};
protoOf(Buffer).p39 = function (minimumCapacity) {
  // Inline function 'kotlin.require' call
  if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
    var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (this.h38_1 == null) {
    var result = SegmentPool_instance.s39();
    this.g38_1 = result;
    this.h38_1 = result;
    return result;
  }
  var t = ensureNotNull(this.h38_1);
  if ((t.q38_1 + minimumCapacity | 0) > 8192 || !t.s38_1) {
    var newTail = t.c39(SegmentPool_instance.s39());
    this.h38_1 = newTail;
    return newTail;
  }
  return t;
};
protoOf(Buffer).t39 = function (source, startIndex, endIndex) {
  // Inline function 'kotlinx.io.checkBounds' call
  var size = source.length;
  checkBounds(toLong(size), toLong(startIndex), toLong(endIndex));
  var currentOffset = startIndex;
  while (currentOffset < endIndex) {
    var tail = this.p39(1);
    var tmp3 = endIndex - currentOffset | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = tail.u39();
    var toCopy = Math.min(tmp3, b);
    tail.v39(source, currentOffset, currentOffset + toCopy | 0);
    currentOffset = currentOffset + toCopy | 0;
  }
  var tmp = this;
  var tmp5 = this.i38_1;
  // Inline function 'kotlin.Long.plus' call
  var other = endIndex - startIndex | 0;
  tmp.i38_1 = tmp5.r2(toLong(other));
};
protoOf(Buffer).x39 = function (source, byteCount) {
  // Inline function 'kotlinx.io.checkByteCount' call
  // Inline function 'kotlin.require' call
  if (!(byteCount.b1(new Long(0, 0)) >= 0)) {
    var message = 'byteCount (' + byteCount.toString() + ') < 0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var remainingByteCount = byteCount;
  while (remainingByteCount.b1(new Long(0, 0)) > 0) {
    var read = source.k39(this, remainingByteCount);
    if (read.equals(new Long(-1, -1))) {
      throw EOFException_init_$Create$_0('Source exhausted before reading ' + byteCount.toString() + ' bytes. ' + ('Only ' + byteCount.s2(remainingByteCount).toString() + ' were read.'));
    }
    remainingByteCount = remainingByteCount.s2(read);
  }
};
protoOf(Buffer).l39 = function (source, byteCount) {
  // Inline function 'kotlin.require' call
  if (!!(source === this)) {
    var message = 'source == this';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  checkOffsetAndCount(source.i38_1, new Long(0, 0), byteCount);
  var remainingByteCount = byteCount;
  while (remainingByteCount.b1(new Long(0, 0)) > 0) {
    if (remainingByteCount.b1(toLong(ensureNotNull(source.g38_1).m())) < 0) {
      var tail = this.h38_1;
      var tmp;
      if (!(tail == null) && tail.s38_1) {
        var tmp1 = remainingByteCount;
        // Inline function 'kotlin.Long.plus' call
        var other = tail.q38_1;
        var tmp3 = tmp1.r2(toLong(other));
        // Inline function 'kotlin.Long.minus' call
        var other_0 = tail.y39() ? 0 : tail.p38_1;
        tmp = tmp3.s2(toLong(other_0)).b1(new Long(8192, 0)) <= 0;
      } else {
        tmp = false;
      }
      if (tmp) {
        ensureNotNull(source.g38_1).a3a(tail, remainingByteCount.d1());
        source.i38_1 = source.i38_1.s2(remainingByteCount);
        this.i38_1 = this.i38_1.r2(remainingByteCount);
        return Unit_instance;
      } else {
        source.g38_1 = ensureNotNull(source.g38_1).z39(remainingByteCount.d1());
      }
    }
    var segmentToMove = ensureNotNull(source.g38_1);
    var movedByteCount = toLong(segmentToMove.m());
    source.g38_1 = segmentToMove.b3a();
    if (source.g38_1 == null) {
      source.h38_1 = null;
    }
    // Inline function 'kotlinx.io.Buffer.pushSegment' call
    if (this.g38_1 == null) {
      this.g38_1 = segmentToMove;
      this.h38_1 = segmentToMove;
    } else if (true) {
      this.h38_1 = ensureNotNull(this.h38_1).c39(segmentToMove).d39();
      if (ensureNotNull(this.h38_1).u38_1 == null) {
        this.g38_1 = this.h38_1;
      }
    } else {
      this.h38_1 = ensureNotNull(this.h38_1).c39(segmentToMove);
    }
    source.i38_1 = source.i38_1.s2(movedByteCount);
    this.i38_1 = this.i38_1.r2(movedByteCount);
    remainingByteCount = remainingByteCount.s2(movedByteCount);
  }
};
protoOf(Buffer).c3a = function (source) {
  var totalBytesRead = new Long(0, 0);
  $l$loop: while (true) {
    var readCount = source.k39(this, new Long(8192, 0));
    if (readCount.equals(new Long(-1, -1)))
      break $l$loop;
    totalBytesRead = totalBytesRead.r2(readCount);
  }
  return totalBytesRead;
};
protoOf(Buffer).d3a = function (byte) {
  this.p39(1).e3a(byte);
  this.i38_1 = this.i38_1.r2(new Long(1, 0));
};
protoOf(Buffer).f3a = function (short) {
  this.p39(2).g3a(short);
  this.i38_1 = this.i38_1.r2(new Long(2, 0));
};
protoOf(Buffer).a4 = function () {
  return Unit_instance;
};
protoOf(Buffer).toString = function () {
  if (this.m().equals(new Long(0, 0)))
    return 'Buffer(size=0)';
  var maxPrintableBytes = 64;
  // Inline function 'kotlinx.io.minOf' call
  var b = this.m();
  // Inline function 'kotlin.comparisons.minOf' call
  var a = toLong(maxPrintableBytes);
  var len = (a.b1(b) <= 0 ? a : b).d1();
  var builder = StringBuilder_init_$Create$(imul(len, 2) + (this.m().b1(toLong(maxPrintableBytes)) > 0 ? 1 : 0) | 0);
  var bytesWritten = 0;
  // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
  var curr = this.g38_1;
  while (!(curr == null)) {
    var tmp4 = get_SegmentReadContextImpl();
    var segment = curr;
    var idx = 0;
    while (bytesWritten < len && idx < segment.m()) {
      var _unary__edvuaz = idx;
      idx = _unary__edvuaz + 1 | 0;
      var b_0 = tmp4.h3a(segment, _unary__edvuaz);
      bytesWritten = bytesWritten + 1 | 0;
      var tmp = get_HEX_DIGIT_CHARS();
      // Inline function 'kotlinx.io.shr' call
      var tmp$ret$2 = b_0 >> 4;
      var tmp_0 = builder.c8(tmp[tmp$ret$2 & 15]);
      var tmp_1 = get_HEX_DIGIT_CHARS();
      // Inline function 'kotlinx.io.and' call
      var tmp$ret$3 = b_0 & 15;
      tmp_0.c8(tmp_1[tmp$ret$3]);
    }
    curr = curr.t38_1;
  }
  if (this.m().b1(toLong(maxPrintableBytes)) > 0) {
    builder.c8(_Char___init__impl__6a9atx(8230));
  }
  return 'Buffer(size=' + this.m().toString() + ' hex=' + builder.toString() + ')';
};
protoOf(Buffer).v38 = function () {
  var oldHead = ensureNotNull(this.g38_1);
  var nextHead = oldHead.t38_1;
  this.g38_1 = nextHead;
  if (nextHead == null) {
    this.h38_1 = null;
  } else {
    nextHead.u38_1 = null;
  }
  oldHead.t38_1 = null;
  SegmentPool_instance.i3a(oldHead);
};
protoOf(Buffer).j3a = function () {
  var oldTail = ensureNotNull(this.h38_1);
  var newTail = oldTail.u38_1;
  this.h38_1 = newTail;
  if (newTail == null) {
    this.g38_1 = null;
  } else {
    newTail.t38_1 = null;
  }
  oldTail.u38_1 = null;
  SegmentPool_instance.i3a(oldTail);
};
function readByteString(_this__u8e3s4, byteCount) {
  return UnsafeByteStringOperations_instance.f38(readByteArray_0(_this__u8e3s4, byteCount));
}
function buffered(_this__u8e3s4) {
  return new RealSource(_this__u8e3s4);
}
function PeekSource(upstream) {
  this.k3a_1 = upstream;
  this.l3a_1 = this.k3a_1.j38();
  this.m3a_1 = this.l3a_1.g38_1;
  var tmp = this;
  var tmp0_safe_receiver = this.l3a_1.g38_1;
  var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p38_1;
  tmp.n3a_1 = tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
  this.o3a_1 = false;
  this.p3a_1 = new Long(0, 0);
}
protoOf(PeekSource).k39 = function (sink, byteCount) {
  // Inline function 'kotlin.check' call
  if (!!this.o3a_1) {
    var message = 'Source is closed.';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  // Inline function 'kotlinx.io.checkByteCount' call
  // Inline function 'kotlin.require' call
  if (!(byteCount.b1(new Long(0, 0)) >= 0)) {
    var message_0 = 'byteCount (' + byteCount.toString() + ') < 0';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.check' call
  if (!(this.m3a_1 == null || (this.m3a_1 === this.l3a_1.g38_1 && this.n3a_1 === ensureNotNull(this.l3a_1.g38_1).p38_1))) {
    var message_1 = 'Peek source is invalid because upstream source was used';
    throw IllegalStateException_init_$Create$(toString(message_1));
  }
  if (byteCount.equals(new Long(0, 0)))
    return new Long(0, 0);
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$7 = this.p3a_1.r2(toLong(1));
  if (!this.k3a_1.m38(tmp$ret$7))
    return new Long(-1, -1);
  if (this.m3a_1 == null && !(this.l3a_1.g38_1 == null)) {
    this.m3a_1 = this.l3a_1.g38_1;
    this.n3a_1 = ensureNotNull(this.l3a_1.g38_1).p38_1;
  }
  // Inline function 'kotlin.comparisons.minOf' call
  var b = this.l3a_1.m().s2(this.p3a_1);
  var toCopy = byteCount.b1(b) <= 0 ? byteCount : b;
  this.l3a_1.a39(sink, this.p3a_1, this.p3a_1.r2(toCopy));
  this.p3a_1 = this.p3a_1.r2(toCopy);
  return toCopy;
};
protoOf(PeekSource).a4 = function () {
  this.o3a_1 = true;
};
function RealSource(source) {
  this.q3a_1 = source;
  this.r3a_1 = false;
  this.s3a_1 = new Buffer();
}
protoOf(RealSource).j38 = function () {
  return this.s3a_1;
};
protoOf(RealSource).k39 = function (sink, byteCount) {
  // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
  // Inline function 'kotlin.check' call
  if (!!this.r3a_1) {
    var message = 'Source is closed.';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(byteCount.b1(new Long(0, 0)) >= 0)) {
    var message_0 = 'byteCount: ' + byteCount.toString();
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  if (this.s3a_1.m().equals(new Long(0, 0))) {
    var read = this.q3a_1.k39(this.s3a_1, new Long(8192, 0));
    if (read.equals(new Long(-1, -1)))
      return new Long(-1, -1);
  }
  // Inline function 'kotlin.comparisons.minOf' call
  var b = this.s3a_1.m();
  var toRead = byteCount.b1(b) <= 0 ? byteCount : b;
  return this.s3a_1.k39(sink, toRead);
};
protoOf(RealSource).k38 = function () {
  // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
  // Inline function 'kotlin.check' call
  if (!!this.r3a_1) {
    var message = 'Source is closed.';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  return this.s3a_1.k38() && this.q3a_1.k39(this.s3a_1, new Long(8192, 0)).equals(new Long(-1, -1));
};
protoOf(RealSource).l38 = function (byteCount) {
  if (!this.m38(byteCount))
    throw EOFException_init_$Create$_0("Source doesn't contain required number of bytes (" + byteCount.toString() + ').');
};
protoOf(RealSource).m38 = function (byteCount) {
  // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
  // Inline function 'kotlin.check' call
  if (!!this.r3a_1) {
    var message = 'Source is closed.';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(byteCount.b1(new Long(0, 0)) >= 0)) {
    var message_0 = 'byteCount: ' + byteCount.toString();
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  while (this.s3a_1.m().b1(byteCount) < 0) {
    if (this.q3a_1.k39(this.s3a_1, new Long(8192, 0)).equals(new Long(-1, -1)))
      return false;
  }
  return true;
};
protoOf(RealSource).n38 = function () {
  this.l38(new Long(1, 0));
  return this.s3a_1.n38();
};
protoOf(RealSource).i39 = function (sink, startIndex, endIndex) {
  // Inline function 'kotlinx.io.checkBounds' call
  var size = sink.length;
  checkBounds(toLong(size), toLong(startIndex), toLong(endIndex));
  if (this.s3a_1.m().equals(new Long(0, 0))) {
    var read = this.q3a_1.k39(this.s3a_1, new Long(8192, 0));
    if (read.equals(new Long(-1, -1)))
      return -1;
  }
  var tmp3 = endIndex - startIndex | 0;
  // Inline function 'kotlinx.io.minOf' call
  var b = this.s3a_1.m();
  // Inline function 'kotlin.comparisons.minOf' call
  var a = toLong(tmp3);
  var toRead = (a.b1(b) <= 0 ? a : b).d1();
  return this.s3a_1.i39(sink, startIndex, startIndex + toRead | 0);
};
protoOf(RealSource).m39 = function (sink, byteCount) {
  try {
    this.l38(byteCount);
  } catch ($p) {
    if ($p instanceof EOFException) {
      var e = $p;
      sink.l39(this.s3a_1, this.s3a_1.m());
      throw e;
    } else {
      throw $p;
    }
  }
  this.s3a_1.m39(sink, byteCount);
};
protoOf(RealSource).n39 = function (sink) {
  var totalBytesWritten = new Long(0, 0);
  while (!this.q3a_1.k39(this.s3a_1, new Long(8192, 0)).equals(new Long(-1, -1))) {
    var emitByteCount = this.s3a_1.e39();
    if (emitByteCount.b1(new Long(0, 0)) > 0) {
      totalBytesWritten = totalBytesWritten.r2(emitByteCount);
      sink.l39(this.s3a_1, emitByteCount);
    }
  }
  if (this.s3a_1.m().b1(new Long(0, 0)) > 0) {
    totalBytesWritten = totalBytesWritten.r2(this.s3a_1.m());
    sink.l39(this.s3a_1, this.s3a_1.m());
  }
  return totalBytesWritten;
};
protoOf(RealSource).x38 = function () {
  this.l38(new Long(2, 0));
  return this.s3a_1.x38();
};
protoOf(RealSource).o39 = function () {
  // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
  // Inline function 'kotlin.check' call
  if (!!this.r3a_1) {
    var message = 'Source is closed.';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  return buffered(new PeekSource(this));
};
protoOf(RealSource).a4 = function () {
  if (this.r3a_1)
    return Unit_instance;
  this.r3a_1 = true;
  this.q3a_1.a4();
  this.s3a_1.d2();
};
protoOf(RealSource).toString = function () {
  return 'buffered(' + toString(this.q3a_1) + ')';
};
function Segment_init_$Init$($this) {
  Segment.call($this);
  $this.o38_1 = new Int8Array(8192);
  $this.s38_1 = true;
  $this.r38_1 = null;
  return $this;
}
function Segment_init_$Create$() {
  return Segment_init_$Init$(objectCreate(protoOf(Segment)));
}
function Segment_init_$Init$_0(data, pos, limit, shareToken, owner, $this) {
  Segment.call($this);
  $this.o38_1 = data;
  $this.p38_1 = pos;
  $this.q38_1 = limit;
  $this.r38_1 = shareToken;
  $this.s38_1 = owner;
  return $this;
}
function Segment_init_$Create$_0(data, pos, limit, shareToken, owner) {
  return Segment_init_$Init$_0(data, pos, limit, shareToken, owner, objectCreate(protoOf(Segment)));
}
function Companion() {
  this.t3a_1 = 8192;
  this.u3a_1 = 1024;
}
protoOf(Companion).v3a = function () {
  return Segment_init_$Create$();
};
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
protoOf(Segment).y39 = function () {
  var tmp1_safe_receiver = this.r38_1;
  var tmp0_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w3a();
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
};
protoOf(Segment).b39 = function () {
  var tmp0_elvis_lhs = this.r38_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = SegmentPool_instance.x3a();
    this.r38_1 = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var t = tmp;
  var tmp_0 = this.p38_1;
  var tmp_1 = this.q38_1;
  // Inline function 'kotlin.also' call
  t.y3a();
  return Segment_init_$Create$_0(this.o38_1, tmp_0, tmp_1, t, false);
};
protoOf(Segment).b3a = function () {
  var result = this.t38_1;
  if (!(this.u38_1 == null)) {
    ensureNotNull(this.u38_1).t38_1 = this.t38_1;
  }
  if (!(this.t38_1 == null)) {
    ensureNotNull(this.t38_1).u38_1 = this.u38_1;
  }
  this.t38_1 = null;
  this.u38_1 = null;
  return result;
};
protoOf(Segment).c39 = function (segment) {
  segment.u38_1 = this;
  segment.t38_1 = this.t38_1;
  if (!(this.t38_1 == null)) {
    ensureNotNull(this.t38_1).u38_1 = segment;
  }
  this.t38_1 = segment;
  return segment;
};
protoOf(Segment).z39 = function (byteCount) {
  // Inline function 'kotlin.require' call
  if (!(byteCount > 0 && byteCount <= (this.q38_1 - this.p38_1 | 0))) {
    var message = 'byteCount out of range';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var prefix;
  if (byteCount >= 1024) {
    prefix = this.b39();
  } else {
    prefix = SegmentPool_instance.s39();
    var tmp1 = this.o38_1;
    var tmp2 = prefix.o38_1;
    var tmp3 = this.p38_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = this.p38_1 + byteCount | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, tmp2, 0, tmp3, endIndex);
  }
  prefix.q38_1 = prefix.p38_1 + byteCount | 0;
  this.p38_1 = this.p38_1 + byteCount | 0;
  if (!(this.u38_1 == null)) {
    ensureNotNull(this.u38_1).c39(prefix);
  } else {
    prefix.t38_1 = this;
    this.u38_1 = prefix;
  }
  return prefix;
};
protoOf(Segment).d39 = function () {
  // Inline function 'kotlin.check' call
  if (!!(this.u38_1 == null)) {
    var message = 'cannot compact';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  if (!ensureNotNull(this.u38_1).s38_1)
    return this;
  var byteCount = this.q38_1 - this.p38_1 | 0;
  var availableByteCount = (8192 - ensureNotNull(this.u38_1).q38_1 | 0) + (ensureNotNull(this.u38_1).y39() ? 0 : ensureNotNull(this.u38_1).p38_1) | 0;
  if (byteCount > availableByteCount)
    return this;
  var predecessor = this.u38_1;
  this.a3a(ensureNotNull(predecessor), byteCount);
  var successor = this.b3a();
  // Inline function 'kotlin.check' call
  if (!(successor == null)) {
    throw IllegalStateException_init_$Create$('Check failed.');
  }
  SegmentPool_instance.i3a(this);
  return predecessor;
};
protoOf(Segment).e3a = function (byte) {
  var _unary__edvuaz = this.q38_1;
  this.q38_1 = _unary__edvuaz + 1 | 0;
  this.o38_1[_unary__edvuaz] = byte;
};
protoOf(Segment).g3a = function (short) {
  var data = this.o38_1;
  var limit = this.q38_1;
  var _unary__edvuaz = limit;
  limit = _unary__edvuaz + 1 | 0;
  data[_unary__edvuaz] = toByte((short >>> 8 | 0) & 255);
  var _unary__edvuaz_0 = limit;
  limit = _unary__edvuaz_0 + 1 | 0;
  data[_unary__edvuaz_0] = toByte(short & 255);
  this.q38_1 = limit;
};
protoOf(Segment).w38 = function () {
  var _unary__edvuaz = this.p38_1;
  this.p38_1 = _unary__edvuaz + 1 | 0;
  return this.o38_1[_unary__edvuaz];
};
protoOf(Segment).y38 = function () {
  var data = this.o38_1;
  var pos = this.p38_1;
  var _unary__edvuaz = pos;
  pos = _unary__edvuaz + 1 | 0;
  // Inline function 'kotlinx.io.and' call
  var tmp = (data[_unary__edvuaz] & 255) << 8;
  var _unary__edvuaz_0 = pos;
  pos = _unary__edvuaz_0 + 1 | 0;
  // Inline function 'kotlinx.io.and' call
  var tmp$ret$1 = data[_unary__edvuaz_0] & 255;
  var s = toShort(tmp | tmp$ret$1);
  this.p38_1 = pos;
  return s;
};
protoOf(Segment).a3a = function (sink, byteCount) {
  // Inline function 'kotlin.check' call
  if (!sink.s38_1) {
    var message = 'only owner can write';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  if ((sink.q38_1 + byteCount | 0) > 8192) {
    if (sink.y39())
      throw IllegalArgumentException_init_$Create$_0();
    if (((sink.q38_1 + byteCount | 0) - sink.p38_1 | 0) > 8192)
      throw IllegalArgumentException_init_$Create$_0();
    var tmp1 = sink.o38_1;
    var tmp2 = sink.o38_1;
    var tmp3 = sink.p38_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = sink.q38_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, tmp2, 0, tmp3, endIndex);
    sink.q38_1 = sink.q38_1 - sink.p38_1 | 0;
    sink.p38_1 = 0;
  }
  var tmp6 = this.o38_1;
  var tmp7 = sink.o38_1;
  var tmp8 = sink.q38_1;
  var tmp9 = this.p38_1;
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex_0 = this.p38_1 + byteCount | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = tmp6;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp_0, tmp7, tmp8, tmp9, endIndex_0);
  sink.q38_1 = sink.q38_1 + byteCount | 0;
  this.p38_1 = this.p38_1 + byteCount | 0;
};
protoOf(Segment).j39 = function (dst, dstStartOffset, dstEndOffset) {
  var len = dstEndOffset - dstStartOffset | 0;
  var tmp0 = this.o38_1;
  var tmp3 = this.p38_1;
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = this.p38_1 + len | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = tmp0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstStartOffset, tmp3, endIndex);
  this.p38_1 = this.p38_1 + len | 0;
};
protoOf(Segment).v39 = function (src, srcStartOffset, srcEndOffset) {
  var tmp1 = this.o38_1;
  // Inline function 'kotlin.collections.copyInto' call
  var destinationOffset = this.q38_1;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, tmp1, destinationOffset, srcStartOffset, srcEndOffset);
  this.q38_1 = this.q38_1 + (srcEndOffset - srcStartOffset | 0) | 0;
};
protoOf(Segment).m = function () {
  return this.q38_1 - this.p38_1 | 0;
};
protoOf(Segment).u39 = function () {
  return this.o38_1.length - this.q38_1 | 0;
};
protoOf(Segment).z3a = function (readOnly) {
  return this.o38_1;
};
protoOf(Segment).g39 = function (index) {
  return this.o38_1[this.p38_1 + index | 0];
};
protoOf(Segment).a3b = function (index, value) {
  this.o38_1[this.q38_1 + index | 0] = value;
};
protoOf(Segment).b3b = function (index, b0, b1) {
  var d = this.o38_1;
  var l = this.q38_1;
  d[l + index | 0] = b0;
  d[(l + index | 0) + 1 | 0] = b1;
};
protoOf(Segment).c3b = function (index, b0, b1, b2) {
  var d = this.o38_1;
  var l = this.q38_1;
  d[l + index | 0] = b0;
  d[(l + index | 0) + 1 | 0] = b1;
  d[(l + index | 0) + 2 | 0] = b2;
};
protoOf(Segment).d3b = function (index, b0, b1, b2, b3) {
  var d = this.o38_1;
  var l = this.q38_1;
  d[l + index | 0] = b0;
  d[(l + index | 0) + 1 | 0] = b1;
  d[(l + index | 0) + 2 | 0] = b2;
  d[(l + index | 0) + 3 | 0] = b3;
};
function Segment() {
  this.p38_1 = 0;
  this.q38_1 = 0;
  this.r38_1 = null;
  this.s38_1 = false;
  this.t38_1 = null;
  this.u38_1 = null;
}
function SegmentCopyTracker() {
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.m() === 0;
}
function AlwaysSharedCopyTracker() {
  AlwaysSharedCopyTracker_instance = this;
  SegmentCopyTracker.call(this);
}
protoOf(AlwaysSharedCopyTracker).w3a = function () {
  return true;
};
protoOf(AlwaysSharedCopyTracker).y3a = function () {
  return Unit_instance;
};
var AlwaysSharedCopyTracker_instance;
function AlwaysSharedCopyTracker_getInstance() {
  if (AlwaysSharedCopyTracker_instance == null)
    new AlwaysSharedCopyTracker();
  return AlwaysSharedCopyTracker_instance;
}
function Sink() {
}
function Source() {
}
function readByteArray(_this__u8e3s4) {
  return readByteArrayImpl(_this__u8e3s4, -1);
}
function readByteArrayImpl(_this__u8e3s4, size) {
  var arraySize = size;
  if (size === -1) {
    var fetchSize = new Long(2147483647, 0);
    while (_this__u8e3s4.j38().m().b1(new Long(2147483647, 0)) < 0 && _this__u8e3s4.m38(fetchSize)) {
      // Inline function 'kotlin.Long.times' call
      fetchSize = fetchSize.t2(toLong(2));
    }
    // Inline function 'kotlin.check' call
    if (!(_this__u8e3s4.j38().m().b1(new Long(2147483647, 0)) < 0)) {
      var message = "Can't create an array of size " + _this__u8e3s4.j38().m().toString();
      throw IllegalStateException_init_$Create$(toString(message));
    }
    arraySize = _this__u8e3s4.j38().m().d1();
  } else {
    _this__u8e3s4.l38(toLong(size));
  }
  var array = new Int8Array(arraySize);
  readTo(_this__u8e3s4.j38(), array);
  return array;
}
function readTo(_this__u8e3s4, sink, startIndex, endIndex) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? sink.length : endIndex;
  // Inline function 'kotlinx.io.checkBounds' call
  var size = sink.length;
  checkBounds(toLong(size), toLong(startIndex), toLong(endIndex));
  var offset = startIndex;
  while (offset < endIndex) {
    var bytesRead = _this__u8e3s4.i39(sink, offset, endIndex);
    if (bytesRead === -1) {
      throw EOFException_init_$Create$_0('Source exhausted before reading ' + (endIndex - startIndex | 0) + ' bytes. ' + ('Only ' + bytesRead + ' bytes were read.'));
    }
    offset = offset + bytesRead | 0;
  }
}
function readByteArray_0(_this__u8e3s4, byteCount) {
  // Inline function 'kotlinx.io.checkByteCount' call
  var byteCount_0 = toLong(byteCount);
  // Inline function 'kotlin.require' call
  if (!(byteCount_0.b1(new Long(0, 0)) >= 0)) {
    var message = 'byteCount (' + byteCount_0.toString() + ') < 0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return readByteArrayImpl(_this__u8e3s4, byteCount);
}
function readString(_this__u8e3s4) {
  _this__u8e3s4.m38(new Long(-1, 2147483647));
  return commonReadUtf8(_this__u8e3s4.j38(), _this__u8e3s4.j38().m());
}
function readString_0(_this__u8e3s4, byteCount) {
  _this__u8e3s4.l38(byteCount);
  return commonReadUtf8(_this__u8e3s4.j38(), byteCount);
}
function readString_1(_this__u8e3s4) {
  return commonReadUtf8(_this__u8e3s4, _this__u8e3s4.m());
}
function commonReadUtf8(_this__u8e3s4, byteCount) {
  if (byteCount.equals(new Long(0, 0)))
    return '';
  // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
  var curr = _this__u8e3s4.g38_1;
  while (!(curr == null)) {
    get_SegmentReadContextImpl();
    if (toLong(curr.m()).b1(byteCount) >= 0) {
      var result = '';
      // Inline function 'kotlinx.io.unsafe.withData' call
      var tmp2 = curr.z3a(true);
      var tmp3 = curr.p38_1;
      var tmp0 = curr.q38_1;
      // Inline function 'kotlin.math.min' call
      var b = tmp3 + byteCount.d1() | 0;
      var tmp$ret$0 = Math.min(tmp0, b);
      result = commonToUtf8String(tmp2, tmp3, tmp$ret$0);
      _this__u8e3s4.h39(byteCount);
      return result;
    }
    return commonToUtf8String(readByteArray_0(_this__u8e3s4, byteCount.d1()));
  }
  // Inline function 'kotlin.error' call
  var message = 'Unreacheable';
  throw IllegalStateException_init_$Create$(toString(message));
}
function writeString(_this__u8e3s4, string, startIndex, endIndex) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? string.length : endIndex;
  // Inline function 'kotlinx.io.checkBounds' call
  var size = string.length;
  checkBounds(toLong(size), toLong(startIndex), toLong(endIndex));
  // Inline function 'kotlinx.io.writeToInternalBuffer' call
  // Inline function 'kotlinx.io.commonWriteUtf8' call
  var this_0 = _this__u8e3s4.j38();
  var i = startIndex;
  while (i < endIndex) {
    var p0 = i;
    // Inline function 'kotlin.code' call
    var this_1 = charSequenceGet(string, p0);
    var c = Char__toInt_impl_vasixd(this_1);
    if (c < 128) {
      $l$block_0: {
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
        var tail = this_0.p39(1);
        var ctx = get_SegmentWriteContextImpl();
        var segmentOffset = -i | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = i + tail.u39() | 0;
        var runLimit = Math.min(endIndex, b);
        var _unary__edvuaz = i;
        i = _unary__edvuaz + 1 | 0;
        ctx.h3b(tail, segmentOffset + _unary__edvuaz | 0, toByte(c));
        $l$loop: while (i < runLimit) {
          var p0_0 = i;
          // Inline function 'kotlin.code' call
          var this_2 = charSequenceGet(string, p0_0);
          c = Char__toInt_impl_vasixd(this_2);
          if (c >= 128)
            break $l$loop;
          var _unary__edvuaz_0 = i;
          i = _unary__edvuaz_0 + 1 | 0;
          ctx.h3b(tail, segmentOffset + _unary__edvuaz_0 | 0, toByte(c));
        }
        var bytesWritten = i + segmentOffset | 0;
        if (bytesWritten === 1) {
          tail.q38_1 = tail.q38_1 + bytesWritten | 0;
          var tmp = this_0;
          // Inline function 'kotlin.Long.plus' call
          tmp.i38_1 = this_0.i38_1.r2(toLong(bytesWritten));
          break $l$block_0;
        }
        // Inline function 'kotlin.check' call
        if (!(0 <= bytesWritten ? bytesWritten <= tail.u39() : false)) {
          var message = 'Invalid number of bytes written: ' + bytesWritten + '. Should be in 0..' + tail.u39();
          throw IllegalStateException_init_$Create$(toString(message));
        }
        if (!(bytesWritten === 0)) {
          tail.q38_1 = tail.q38_1 + bytesWritten | 0;
          var tmp_0 = this_0;
          // Inline function 'kotlin.Long.plus' call
          tmp_0.i38_1 = this_0.i38_1.r2(toLong(bytesWritten));
          break $l$block_0;
        }
        if (isEmpty(tail)) {
          this_0.j3a();
        }
      }
    } else if (c < 2048) {
      $l$block_2: {
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
        var tail_0 = this_0.p39(2);
        get_SegmentWriteContextImpl().g3b(tail_0, 0, toByte(c >> 6 | 192), toByte(c & 63 | 128));
        var bytesWritten_0 = 2;
        if (bytesWritten_0 === 2) {
          tail_0.q38_1 = tail_0.q38_1 + bytesWritten_0 | 0;
          var tmp_1 = this_0;
          // Inline function 'kotlin.Long.plus' call
          tmp_1.i38_1 = this_0.i38_1.r2(toLong(bytesWritten_0));
          break $l$block_2;
        }
        // Inline function 'kotlin.check' call
        if (!(0 <= bytesWritten_0 ? bytesWritten_0 <= tail_0.u39() : false)) {
          var message_0 = 'Invalid number of bytes written: ' + bytesWritten_0 + '. Should be in 0..' + tail_0.u39();
          throw IllegalStateException_init_$Create$(toString(message_0));
        }
        if (!(bytesWritten_0 === 0)) {
          tail_0.q38_1 = tail_0.q38_1 + bytesWritten_0 | 0;
          var tmp_2 = this_0;
          // Inline function 'kotlin.Long.plus' call
          tmp_2.i38_1 = this_0.i38_1.r2(toLong(bytesWritten_0));
          break $l$block_2;
        }
        if (isEmpty(tail_0)) {
          this_0.j3a();
        }
      }
      i = i + 1 | 0;
    } else if (c < 55296 || c > 57343) {
      $l$block_4: {
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
        var tail_1 = this_0.p39(3);
        get_SegmentWriteContextImpl().f3b(tail_1, 0, toByte(c >> 12 | 224), toByte(c >> 6 & 63 | 128), toByte(c & 63 | 128));
        var bytesWritten_1 = 3;
        if (bytesWritten_1 === 3) {
          tail_1.q38_1 = tail_1.q38_1 + bytesWritten_1 | 0;
          var tmp_3 = this_0;
          // Inline function 'kotlin.Long.plus' call
          tmp_3.i38_1 = this_0.i38_1.r2(toLong(bytesWritten_1));
          break $l$block_4;
        }
        // Inline function 'kotlin.check' call
        if (!(0 <= bytesWritten_1 ? bytesWritten_1 <= tail_1.u39() : false)) {
          var message_1 = 'Invalid number of bytes written: ' + bytesWritten_1 + '. Should be in 0..' + tail_1.u39();
          throw IllegalStateException_init_$Create$(toString(message_1));
        }
        if (!(bytesWritten_1 === 0)) {
          tail_1.q38_1 = tail_1.q38_1 + bytesWritten_1 | 0;
          var tmp_4 = this_0;
          // Inline function 'kotlin.Long.plus' call
          tmp_4.i38_1 = this_0.i38_1.r2(toLong(bytesWritten_1));
          break $l$block_4;
        }
        if (isEmpty(tail_1)) {
          this_0.j3a();
        }
      }
      i = i + 1 | 0;
    } else {
      var tmp_5;
      if ((i + 1 | 0) < endIndex) {
        var p0_1 = i + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_3 = charSequenceGet(string, p0_1);
        tmp_5 = Char__toInt_impl_vasixd(this_3);
      } else {
        tmp_5 = 0;
      }
      var low = tmp_5;
      if (c > 56319 || !(56320 <= low ? low <= 57343 : false)) {
        // Inline function 'kotlin.code' call
        var this_4 = _Char___init__impl__6a9atx(63);
        var tmp$ret$26 = Char__toInt_impl_vasixd(this_4);
        this_0.d3a(toByte(tmp$ret$26));
        i = i + 1 | 0;
      } else {
        var codePoint = 65536 + ((c & 1023) << 10 | low & 1023) | 0;
        $l$block_6: {
          // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
          var tail_2 = this_0.p39(4);
          get_SegmentWriteContextImpl().e3b(tail_2, 0, toByte(codePoint >> 18 | 240), toByte(codePoint >> 12 & 63 | 128), toByte(codePoint >> 6 & 63 | 128), toByte(codePoint & 63 | 128));
          var bytesWritten_2 = 4;
          if (bytesWritten_2 === 4) {
            tail_2.q38_1 = tail_2.q38_1 + bytesWritten_2 | 0;
            var tmp_6 = this_0;
            // Inline function 'kotlin.Long.plus' call
            tmp_6.i38_1 = this_0.i38_1.r2(toLong(bytesWritten_2));
            break $l$block_6;
          }
          // Inline function 'kotlin.check' call
          if (!(0 <= bytesWritten_2 ? bytesWritten_2 <= tail_2.u39() : false)) {
            var message_2 = 'Invalid number of bytes written: ' + bytesWritten_2 + '. Should be in 0..' + tail_2.u39();
            throw IllegalStateException_init_$Create$(toString(message_2));
          }
          if (!(bytesWritten_2 === 0)) {
            tail_2.q38_1 = tail_2.q38_1 + bytesWritten_2 | 0;
            var tmp_7 = this_0;
            // Inline function 'kotlin.Long.plus' call
            tmp_7.i38_1 = this_0.i38_1.r2(toLong(bytesWritten_2));
            break $l$block_6;
          }
          if (isEmpty(tail_2)) {
            this_0.j3a();
          }
        }
        i = i + 2 | 0;
      }
    }
  }
  _this__u8e3s4.z38();
}
function commonToUtf8String(_this__u8e3s4, beginIndex, endIndex) {
  beginIndex = beginIndex === VOID ? 0 : beginIndex;
  endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
  if (beginIndex < 0 || endIndex > _this__u8e3s4.length || beginIndex > endIndex) {
    throw IndexOutOfBoundsException_init_$Create$('size=' + _this__u8e3s4.length + ' beginIndex=' + beginIndex + ' endIndex=' + endIndex);
  }
  var chars = charArray(endIndex - beginIndex | 0);
  var length = 0;
  // Inline function 'kotlinx.io.internal.processUtf16Chars' call
  var index = beginIndex;
  while (index < endIndex) {
    var b0 = _this__u8e3s4[index];
    if (b0 >= 0) {
      var c = numberToChar(b0);
      var _unary__edvuaz = length;
      length = _unary__edvuaz + 1 | 0;
      chars[_unary__edvuaz] = c;
      index = index + 1 | 0;
      while (index < endIndex && _this__u8e3s4[index] >= 0) {
        var _unary__edvuaz_0 = index;
        index = _unary__edvuaz_0 + 1 | 0;
        var c_0 = numberToChar(_this__u8e3s4[_unary__edvuaz_0]);
        var _unary__edvuaz_1 = length;
        length = _unary__edvuaz_1 + 1 | 0;
        chars[_unary__edvuaz_1] = c_0;
      }
    } else {
      // Inline function 'kotlinx.io.shr' call
      if (b0 >> 5 === -2) {
        var tmp = index;
        var tmp3 = index;
        var tmp$ret$5;
        $l$block_0: {
          // Inline function 'kotlinx.io.internal.process2Utf8Bytes' call
          if (endIndex <= (tmp3 + 1 | 0)) {
            var c_1 = numberToChar(65533);
            var _unary__edvuaz_2 = length;
            length = _unary__edvuaz_2 + 1 | 0;
            chars[_unary__edvuaz_2] = c_1;
            tmp$ret$5 = 1;
            break $l$block_0;
          }
          var b0_0 = _this__u8e3s4[tmp3];
          var b1 = _this__u8e3s4[tmp3 + 1 | 0];
          // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
          // Inline function 'kotlinx.io.and' call
          if (!((b1 & 192) === 128)) {
            var c_2 = numberToChar(65533);
            var _unary__edvuaz_3 = length;
            length = _unary__edvuaz_3 + 1 | 0;
            chars[_unary__edvuaz_3] = c_2;
            tmp$ret$5 = 1;
            break $l$block_0;
          }
          var codePoint = 3968 ^ b1 ^ b0_0 << 6;
          if (codePoint < 128) {
            var c_3 = numberToChar(65533);
            var _unary__edvuaz_4 = length;
            length = _unary__edvuaz_4 + 1 | 0;
            chars[_unary__edvuaz_4] = c_3;
          } else {
            var c_4 = numberToChar(codePoint);
            var _unary__edvuaz_5 = length;
            length = _unary__edvuaz_5 + 1 | 0;
            chars[_unary__edvuaz_5] = c_4;
          }
          tmp$ret$5 = 2;
        }
        index = tmp + tmp$ret$5 | 0;
      } else {
        // Inline function 'kotlinx.io.shr' call
        if (b0 >> 4 === -2) {
          var tmp_0 = index;
          var tmp12 = index;
          var tmp$ret$19;
          $l$block_4: {
            // Inline function 'kotlinx.io.internal.process3Utf8Bytes' call
            if (endIndex <= (tmp12 + 2 | 0)) {
              var c_5 = numberToChar(65533);
              var _unary__edvuaz_6 = length;
              length = _unary__edvuaz_6 + 1 | 0;
              chars[_unary__edvuaz_6] = c_5;
              var tmp_1;
              if (endIndex <= (tmp12 + 1 | 0)) {
                tmp_1 = true;
              } else {
                // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                // Inline function 'kotlinx.io.and' call
                tmp_1 = !((_this__u8e3s4[tmp12 + 1 | 0] & 192) === 128);
              }
              if (tmp_1) {
                tmp$ret$19 = 1;
                break $l$block_4;
              } else {
                tmp$ret$19 = 2;
                break $l$block_4;
              }
            }
            var b0_1 = _this__u8e3s4[tmp12];
            var b1_0 = _this__u8e3s4[tmp12 + 1 | 0];
            // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
            // Inline function 'kotlinx.io.and' call
            if (!((b1_0 & 192) === 128)) {
              var c_6 = numberToChar(65533);
              var _unary__edvuaz_7 = length;
              length = _unary__edvuaz_7 + 1 | 0;
              chars[_unary__edvuaz_7] = c_6;
              tmp$ret$19 = 1;
              break $l$block_4;
            }
            var b2 = _this__u8e3s4[tmp12 + 2 | 0];
            // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
            // Inline function 'kotlinx.io.and' call
            if (!((b2 & 192) === 128)) {
              var c_7 = numberToChar(65533);
              var _unary__edvuaz_8 = length;
              length = _unary__edvuaz_8 + 1 | 0;
              chars[_unary__edvuaz_8] = c_7;
              tmp$ret$19 = 2;
              break $l$block_4;
            }
            var codePoint_0 = -123008 ^ b2 ^ b1_0 << 6 ^ b0_1 << 12;
            if (codePoint_0 < 2048) {
              var c_8 = numberToChar(65533);
              var _unary__edvuaz_9 = length;
              length = _unary__edvuaz_9 + 1 | 0;
              chars[_unary__edvuaz_9] = c_8;
            } else if (55296 <= codePoint_0 ? codePoint_0 <= 57343 : false) {
              var c_9 = numberToChar(65533);
              var _unary__edvuaz_10 = length;
              length = _unary__edvuaz_10 + 1 | 0;
              chars[_unary__edvuaz_10] = c_9;
            } else {
              var c_10 = numberToChar(codePoint_0);
              var _unary__edvuaz_11 = length;
              length = _unary__edvuaz_11 + 1 | 0;
              chars[_unary__edvuaz_11] = c_10;
            }
            tmp$ret$19 = 3;
          }
          index = tmp_0 + tmp$ret$19 | 0;
        } else {
          // Inline function 'kotlinx.io.shr' call
          if (b0 >> 3 === -2) {
            var tmp_2 = index;
            var tmp23 = index;
            var tmp$ret$41;
            $l$block_10: {
              // Inline function 'kotlinx.io.internal.process4Utf8Bytes' call
              if (endIndex <= (tmp23 + 3 | 0)) {
                if (!(65533 === 65533)) {
                  var c_11 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_12 = length;
                  length = _unary__edvuaz_12 + 1 | 0;
                  chars[_unary__edvuaz_12] = c_11;
                  var c_12 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_13 = length;
                  length = _unary__edvuaz_13 + 1 | 0;
                  chars[_unary__edvuaz_13] = c_12;
                } else {
                  var c_13 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_14 = length;
                  length = _unary__edvuaz_14 + 1 | 0;
                  chars[_unary__edvuaz_14] = c_13;
                }
                var tmp_3;
                if (endIndex <= (tmp23 + 1 | 0)) {
                  tmp_3 = true;
                } else {
                  // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                  // Inline function 'kotlinx.io.and' call
                  tmp_3 = !((_this__u8e3s4[tmp23 + 1 | 0] & 192) === 128);
                }
                if (tmp_3) {
                  tmp$ret$41 = 1;
                  break $l$block_10;
                } else {
                  var tmp_4;
                  if (endIndex <= (tmp23 + 2 | 0)) {
                    tmp_4 = true;
                  } else {
                    // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                    // Inline function 'kotlinx.io.and' call
                    tmp_4 = !((_this__u8e3s4[tmp23 + 2 | 0] & 192) === 128);
                  }
                  if (tmp_4) {
                    tmp$ret$41 = 2;
                    break $l$block_10;
                  } else {
                    tmp$ret$41 = 3;
                    break $l$block_10;
                  }
                }
              }
              var b0_2 = _this__u8e3s4[tmp23];
              var b1_1 = _this__u8e3s4[tmp23 + 1 | 0];
              // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
              // Inline function 'kotlinx.io.and' call
              if (!((b1_1 & 192) === 128)) {
                if (!(65533 === 65533)) {
                  var c_14 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_15 = length;
                  length = _unary__edvuaz_15 + 1 | 0;
                  chars[_unary__edvuaz_15] = c_14;
                  var c_15 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_16 = length;
                  length = _unary__edvuaz_16 + 1 | 0;
                  chars[_unary__edvuaz_16] = c_15;
                } else {
                  var c_16 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_17 = length;
                  length = _unary__edvuaz_17 + 1 | 0;
                  chars[_unary__edvuaz_17] = c_16;
                }
                tmp$ret$41 = 1;
                break $l$block_10;
              }
              var b2_0 = _this__u8e3s4[tmp23 + 2 | 0];
              // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
              // Inline function 'kotlinx.io.and' call
              if (!((b2_0 & 192) === 128)) {
                if (!(65533 === 65533)) {
                  var c_17 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_18 = length;
                  length = _unary__edvuaz_18 + 1 | 0;
                  chars[_unary__edvuaz_18] = c_17;
                  var c_18 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_19 = length;
                  length = _unary__edvuaz_19 + 1 | 0;
                  chars[_unary__edvuaz_19] = c_18;
                } else {
                  var c_19 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_20 = length;
                  length = _unary__edvuaz_20 + 1 | 0;
                  chars[_unary__edvuaz_20] = c_19;
                }
                tmp$ret$41 = 2;
                break $l$block_10;
              }
              var b3 = _this__u8e3s4[tmp23 + 3 | 0];
              // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
              // Inline function 'kotlinx.io.and' call
              if (!((b3 & 192) === 128)) {
                if (!(65533 === 65533)) {
                  var c_20 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_21 = length;
                  length = _unary__edvuaz_21 + 1 | 0;
                  chars[_unary__edvuaz_21] = c_20;
                  var c_21 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_22 = length;
                  length = _unary__edvuaz_22 + 1 | 0;
                  chars[_unary__edvuaz_22] = c_21;
                } else {
                  var c_22 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_23 = length;
                  length = _unary__edvuaz_23 + 1 | 0;
                  chars[_unary__edvuaz_23] = c_22;
                }
                tmp$ret$41 = 3;
                break $l$block_10;
              }
              var codePoint_1 = 3678080 ^ b3 ^ b2_0 << 6 ^ b1_1 << 12 ^ b0_2 << 18;
              if (codePoint_1 > 1114111) {
                if (!(65533 === 65533)) {
                  var c_23 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_24 = length;
                  length = _unary__edvuaz_24 + 1 | 0;
                  chars[_unary__edvuaz_24] = c_23;
                  var c_24 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_25 = length;
                  length = _unary__edvuaz_25 + 1 | 0;
                  chars[_unary__edvuaz_25] = c_24;
                } else {
                  var c_25 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_26 = length;
                  length = _unary__edvuaz_26 + 1 | 0;
                  chars[_unary__edvuaz_26] = c_25;
                }
              } else if (55296 <= codePoint_1 ? codePoint_1 <= 57343 : false) {
                if (!(65533 === 65533)) {
                  var c_26 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_27 = length;
                  length = _unary__edvuaz_27 + 1 | 0;
                  chars[_unary__edvuaz_27] = c_26;
                  var c_27 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_28 = length;
                  length = _unary__edvuaz_28 + 1 | 0;
                  chars[_unary__edvuaz_28] = c_27;
                } else {
                  var c_28 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_29 = length;
                  length = _unary__edvuaz_29 + 1 | 0;
                  chars[_unary__edvuaz_29] = c_28;
                }
              } else if (codePoint_1 < 65536) {
                if (!(65533 === 65533)) {
                  var c_29 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_30 = length;
                  length = _unary__edvuaz_30 + 1 | 0;
                  chars[_unary__edvuaz_30] = c_29;
                  var c_30 = numberToChar((65533 & 1023) + 56320 | 0);
                  var _unary__edvuaz_31 = length;
                  length = _unary__edvuaz_31 + 1 | 0;
                  chars[_unary__edvuaz_31] = c_30;
                } else {
                  var c_31 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_32 = length;
                  length = _unary__edvuaz_32 + 1 | 0;
                  chars[_unary__edvuaz_32] = c_31;
                }
              } else {
                if (!(codePoint_1 === 65533)) {
                  var c_32 = numberToChar((codePoint_1 >>> 10 | 0) + 55232 | 0);
                  var _unary__edvuaz_33 = length;
                  length = _unary__edvuaz_33 + 1 | 0;
                  chars[_unary__edvuaz_33] = c_32;
                  var c_33 = numberToChar((codePoint_1 & 1023) + 56320 | 0);
                  var _unary__edvuaz_34 = length;
                  length = _unary__edvuaz_34 + 1 | 0;
                  chars[_unary__edvuaz_34] = c_33;
                } else {
                  var c_34 = _Char___init__impl__6a9atx(65533);
                  var _unary__edvuaz_35 = length;
                  length = _unary__edvuaz_35 + 1 | 0;
                  chars[_unary__edvuaz_35] = c_34;
                }
              }
              tmp$ret$41 = 4;
            }
            index = tmp_2 + tmp$ret$41 | 0;
          } else {
            var c_35 = _Char___init__impl__6a9atx(65533);
            var _unary__edvuaz_36 = length;
            length = _unary__edvuaz_36 + 1 | 0;
            chars[_unary__edvuaz_36] = c_35;
            index = index + 1 | 0;
          }
        }
      }
    }
  }
  return concatToString(chars, 0, length);
}
function get_SegmentReadContextImpl() {
  _init_properties_UnsafeBufferOperations_kt__xw75gy();
  return SegmentReadContextImpl;
}
var SegmentReadContextImpl;
function get_SegmentWriteContextImpl() {
  _init_properties_UnsafeBufferOperations_kt__xw75gy();
  return SegmentWriteContextImpl;
}
var SegmentWriteContextImpl;
var BufferIterationContextImpl;
function UnsafeBufferOperations() {
}
var UnsafeBufferOperations_instance;
function UnsafeBufferOperations_getInstance() {
  return UnsafeBufferOperations_instance;
}
function SegmentReadContextImpl$1() {
}
protoOf(SegmentReadContextImpl$1).h3a = function (segment, offset) {
  return segment.g39(offset);
};
function SegmentWriteContextImpl$1() {
}
protoOf(SegmentWriteContextImpl$1).h3b = function (segment, offset, value) {
  segment.a3b(offset, value);
};
protoOf(SegmentWriteContextImpl$1).g3b = function (segment, offset, b0, b1) {
  segment.b3b(offset, b0, b1);
};
protoOf(SegmentWriteContextImpl$1).f3b = function (segment, offset, b0, b1, b2) {
  segment.c3b(offset, b0, b1, b2);
};
protoOf(SegmentWriteContextImpl$1).e3b = function (segment, offset, b0, b1, b2, b3) {
  segment.d3b(offset, b0, b1, b2, b3);
};
function BufferIterationContextImpl$1() {
}
protoOf(BufferIterationContextImpl$1).h3a = function (segment, offset) {
  return get_SegmentReadContextImpl().h3a(segment, offset);
};
var properties_initialized_UnsafeBufferOperations_kt_2xfgoc;
function _init_properties_UnsafeBufferOperations_kt__xw75gy() {
  if (!properties_initialized_UnsafeBufferOperations_kt_2xfgoc) {
    properties_initialized_UnsafeBufferOperations_kt_2xfgoc = true;
    SegmentReadContextImpl = new SegmentReadContextImpl$1();
    SegmentWriteContextImpl = new SegmentWriteContextImpl$1();
    BufferIterationContextImpl = new BufferIterationContextImpl$1();
  }
}
function IOException_init_$Init$($this) {
  Exception_init_$Init$($this);
  IOException.call($this);
  return $this;
}
function IOException_init_$Create$() {
  var tmp = IOException_init_$Init$(objectCreate(protoOf(IOException)));
  captureStack(tmp, IOException_init_$Create$);
  return tmp;
}
function IOException_init_$Init$_0(message, $this) {
  Exception_init_$Init$_0(message, $this);
  IOException.call($this);
  return $this;
}
function IOException_init_$Create$_0(message) {
  var tmp = IOException_init_$Init$_0(message, objectCreate(protoOf(IOException)));
  captureStack(tmp, IOException_init_$Create$_0);
  return tmp;
}
function IOException_init_$Init$_1(message, cause, $this) {
  Exception_init_$Init$_1(message, cause, $this);
  IOException.call($this);
  return $this;
}
function IOException_init_$Create$_1(message, cause) {
  var tmp = IOException_init_$Init$_1(message, cause, objectCreate(protoOf(IOException)));
  captureStack(tmp, IOException_init_$Create$_1);
  return tmp;
}
function IOException() {
  captureStack(this, IOException);
}
function EOFException_init_$Init$($this) {
  IOException_init_$Init$($this);
  EOFException.call($this);
  return $this;
}
function EOFException_init_$Create$() {
  var tmp = EOFException_init_$Init$(objectCreate(protoOf(EOFException)));
  captureStack(tmp, EOFException_init_$Create$);
  return tmp;
}
function EOFException_init_$Init$_0(message, $this) {
  IOException_init_$Init$_0(message, $this);
  EOFException.call($this);
  return $this;
}
function EOFException_init_$Create$_0(message) {
  var tmp = EOFException_init_$Init$_0(message, objectCreate(protoOf(EOFException)));
  captureStack(tmp, EOFException_init_$Create$_0);
  return tmp;
}
function EOFException() {
  captureStack(this, EOFException);
}
function SegmentPool() {
  this.q39_1 = 0;
  this.r39_1 = 0;
}
protoOf(SegmentPool).s39 = function () {
  return Companion_instance.v3a();
};
protoOf(SegmentPool).i3a = function (segment) {
};
protoOf(SegmentPool).x3a = function () {
  return AlwaysSharedCopyTracker_getInstance();
};
var SegmentPool_instance;
function SegmentPool_getInstance() {
  return SegmentPool_instance;
}
//region block: post-declaration
protoOf(Buffer).w39 = write$default;
//endregion
//region block: init
Companion_instance = new Companion();
UnsafeBufferOperations_instance = new UnsafeBufferOperations();
SegmentPool_instance = new SegmentPool();
//endregion
//region block: exports
export {
  EOFException_init_$Create$_0 as EOFException_init_$Create$1fcl7h9im3v9r,
  IOException_init_$Init$_0 as IOException_init_$Init$2jjz3fe04l3kq,
  IOException_init_$Create$_0 as IOException_init_$Create$13y6ig657l2av,
  IOException_init_$Init$_1 as IOException_init_$Init$2zqugtfkvfigo,
  IOException_init_$Create$_1 as IOException_init_$Create$39p2wsfj1vt0k,
  Buffer as Buffergs925ekssbch,
  IOException as IOException1wyutdmfe71nu,
  Source as Source1shr0ps16u4p4,
  readByteArray_0 as readByteArray1fhzfwi2j014k,
  readByteArray as readByteArray1ri21h2rciakw,
  readByteString as readByteString2hnsbql6t4ads,
  readString as readString2nvggcfaijfhd,
  readString_0 as readString3v6duspiz33tv,
  readString_1 as readStringo8i62qxt5m4m,
  writeString as writeString33ca4btrgctw7,
};
//endregion

